var map = {
	"./android.svg": "d2c1",
	"./angular.svg": "8350",
	"./aog.png": "0f8b",
	"./csharp.svg": "4dbb",
	"./firebase.svg": "f558",
	"./gcp.svg": "8d14",
	"./javascript.svg": "54e1",
	"./nodejs.svg": "e0ae",
	"./notFound.png": "1d36",
	"./polymer.svg": "5c35",
	"./swift.svg": "77db",
	"./tf.svg": "4805",
	"./vuejs.svg": "4f01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fc8";